import * as React from "react";

function SvgVidora(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g clipPath="url(#Vidora_svg__clip0)">
        <path
          d="M86.3 61.7c0-10.2 8.3-18.5 18.5-18.5H61.7c-10.2 0-18.5 8.3-18.5 18.5s8.3 18.5 18.5 18.5h43.2c-10.3.1-18.6-8.2-18.6-18.5z"
          fill="#420FBF"
        />
        <path
          d="M37.1 18.5c0 10.2-8.3 18.5-18.5 18.5h43.2c10.2 0 18.5-8.3 18.5-18.5S72 0 61.7 0H18.5c10.3 0 18.6 8.3 18.6 18.5zM18.5 43.2C8.3 43.2 0 51.5 0 61.7 0 72 8.3 80.3 18.5 80.3S37 72 37 61.8c.1-10.3-8.2-18.6-18.5-18.6zm86.4 0c-10.2 0-18.5 8.3-18.5 18.5s8.3 18.5 18.5 18.5 18.5-8.3 18.5-18.5-8.3-18.5-18.5-18.5z"
          fill="#6626FF"
        />
        <path
          d="M104.9 37.1c10.2 0 18.5-8.3 18.5-18.5S115.1.1 104.9.1C94.6 0 86.3 8.3 86.3 18.5c0 10.3 8.3 18.6 18.6 18.6zm-86.4 0c10.2 0 18.5-8.3 18.5-18.5C37.1 8.3 28.8 0 18.5 0 8.3 0 0 8.3 0 18.5c0 10.3 8.3 18.6 18.5 18.6z"
          fill="#420FBF"
        />
      </g>
      <defs>
        <clipPath id="Vidora_svg__clip0">
          <path fill="#fff" d="M0 0h436.1v80.3H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.forwardRef(SvgVidora);
